import SettingsIcon from '@mui/icons-material/Settings';
import { IconButton, TableCell, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

export default class TableConfigCell extends PureComponent {
  static propTypes = {
    toggleColumnDialog: PropTypes.func.isRequired
  };

  render() {
    const { toggleColumnDialog } = this.props;
    const title = 'Table Column Preferences';
    return (
      <TableCell padding="none" width="64">
        <Tooltip title={title}>
          <IconButton onClick={toggleColumnDialog} color="primary" size="large">
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    );
  }
}
